<template>
  <div>
    <label-tag :tagArray="['學習點', '任務']" v-on:getSence="getSence" :currentTag="1"/>
    <div class="px-5 table-responsive" style="overflow:auto; min-height:50vh;font-size:1.25rem">
      <table class="table table-borderless table-hover">
        <thead>
          <tr>
            <th class="order-btn pointer">
              {{$t('username')}}
              <font-awesome-icon class="form_icon" :icon="['fas', 'sort-down']" />
            </th>
            <th>{{$t('name')}}</th>
            <th class="order-btn pointer">
              任務名稱
              <font-awesome-icon class="form_icon" :icon="['fas', 'sort-down']" />
            </th>
            <th class="order-btn pointer">
              最高任務評價
              <font-awesome-icon class="form_icon" :icon="['fas', 'sort-down']" />
            </th>
            <th class="order-btn pointer">
              完成時間
              <font-awesome-icon class="form_icon" :icon="['fas', 'sort-down']" />
            </th>
            <th>
              任務全紀錄
            </th>
          </tr>
        </thead>
        <tbody style="border-top:1px #cccccc solid;text-align: left;">
          <tr v-for="(item , index) in record.data" :key="index">
            <td>
              {{item.userName}}
            </td>
            <td>
              {{item.realName}}
            </td>
            <td>
              {{item.sceneName?item.sceneName:'-'}}
            </td>
            <td>
              {{item.grade?item.grade:'-'}}
            </td>
            <td>
              {{item.spendTime}}
            </td>
            <td >
              <a v-if="item.spendTime ==='0:00:00'" class="disabled" href="javascript:void(0);">
                個人任務歷程
              </a>
              <a v-else @click="goInfo(item.userId)" href="javascript:void(0);">
                個人任務歷程
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <Pagination class="mt-5" :current="record.pageIndex" :total="record.pageCount" v-on:page="updatePage" />
  </div>
</template>

<script>
import api from '../../../../store/api'
import Pagination from '../../../../components/Pagination'
import labelTag from '../../tw/record/Label'
export default {

  name: 'TWRecordMission',

  data () {
    return {
      record: {},
      pageIndex: 1,
      orderBy: 'userName',
      senceId: '',
      recognizeData: []
    }
  },
  components: {
    labelTag,
    Pagination
  },
  computed: {
    groupId () {
      return this.$route.params.class
    },
    userAuth () {
      return this.$store.state.auth
    }
  },
  mounted () {
    this.getRecordData()
  },
  methods: {
    updatePage (page) {
      this.pageIndex = page
      this.getRecordData()
    },
    async getRecordData (id) {
      // if (this.userAuth.userRole === 'Teacher') {
      const { data } = await api.get(`/TravelTaiwan/Record/Group/${this.groupId}/Students/MissionScene/Summary`, {
        params: {
          sceneId: id,
          pageIndex: this.pageIndex,
          pageSize: 20
        }
      })
      this.record = data
      // } else {
      //   const { data } = await api.get(`/TravelTaiwan/Record/MissionScene/App/Summary`, {
      //     params: {
      //       userId: this.userAuth.user.id,
      //       sceneId: id,
      //       pageIndex: this.pageIndex,
      //       pageSize: 20
      //     }
      //   })
      //   this.record = data
      // }
    },
    getSence (val) {
      this.senceId = val
      this.getRecordData(val)
    },
    goInfo (id) {
      this.$router.push({name: 'Record.mission.info', params: {student: id, topic: this.senceId}})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/style/color.scss";
  .list-box {
    width: 60%;
    margin: auto;
  }
  .menu-box {
    cursor: pointer;
    text-align: left;
    background-color: #fff;
    border-radius: 10px;
    border: 1.5px solid #6666;
    margin: 10px auto;
    padding: 10px 20px;
    p {
      margin: 0;
    }
      &:hover {
      box-shadow:0px 0px 8px #a1a1a1;
    }
  }
  .order-btn {
    color: rgb(1, 1, 187);
  }
  .disabled {
    color: #a1a1a1;
    text-decoration: none;
    cursor: auto;
  }
</style>


// WEBPACK FOOTER //
// RecordMission.vue?69acf068